angular.module("app").factory("deepCompare", [
    function () {
        function compare (obj1, obj2) {
            return angular.equals(obj1, obj2)
        }

        function getChanges(prev, now, initializator, defaultValue) {
            var changes = {}, prop, pc;
            if (Array.isArray(prev) && Array.isArray(now)) {
                changes = [];
            }
            for (prop in now) {
                if (!prev) {
                    changes[prop] = now[prop]
                } else {
                    if (prev[prop] !== now[prop]) {
                        if (typeof now[prop] == "object" && now[prop] !== null) {
                            if(pc = getChanges(prev[prop], now[prop], initializator))
                                changes[prop] = pc;
                        } else if (prop !== "$$hashKey") {
                            changes[prop] = now[prop];
                            if (initializator) {
                                changes[initializator] = now[initializator];
                            }
                        }
                    }
                }
            }
            for (prop in changes)
                return changes;
            return defaultValue || false; // false when unchanged
        }

        return {
            isEqual: compare,
            getChanges:  getChanges
        }
    }
]);